<po-page-default p-title="Exibir dados de Item de Lote">
    <div class="barcode-wrapper">
        <po-input #itemBarcodeInput name="itemBarcode" p-icon="an an-barcode" p-placeholder="Digite ou escaneie a barra"
            [(ngModel)]="barcode" (keydown.enter)="fetchItemData()" (keydown.tab)="fetchItemData(); $event.preventDefault()">
        </po-input>

        <button type="button" class="barcode-scan-btn btn-item" (click)="toggleScanner()" title="Ler código com câmera">
            <span class="po-icon po-icon-camera"></span>
        </button>
    </div>
    <div class="clear-btn-container">
        <po-button p-label="Limpar" p-kind="secondary" (p-click)="onClear()">
        </po-button>
    </div>

    <div class="scanner-box" *ngIf="scannerVisible">
        <zxing-scanner [autostart]="true" [device]="selectedDevice" [formats]="formatsEnabled" [tryHarder]="true"
            (scanSuccess)="onBarcodeScanned($event)">
        </zxing-scanner>
    </div>

    <po-widget *ngIf="itemData">
        <div class="po-row po-mb-1" style="font-size: 0.85rem;">
            <div class="po-col po-sm-4">
                <label><strong>Empresa:</strong> {{itemData.company}}</label>
            </div>
            <div class="po-col po-sm-4">
                <label><strong>Lote:</strong> {{itemData.batch}}</label>
            </div>
            <div class="po-col po-sm-4">
                <label><strong>Item:</strong> {{itemData.item}}</label>
            </div>
            <div class="po-col po-sm-12">
                <label><strong>Produto:</strong> {{itemData.product}}</label>
            </div>
            <div class="po-col po-sm-12">
                <label><strong>Barras:</strong> {{itemData.barcode}}</label>
            </div>
            <div class="po-col po-sm-6 po-md-6">
                <label><strong>Quantidade:</strong> {{itemData.quantity | number:'1.0-2'}}</label>
            </div>
            <div class="po-col po-sm-6 po-md-6">
                <label><strong>Pendente:</strong> {{itemData.pending | number:'1.0-2'}}</label>
            </div>
            <div class="po-col po-sm-12 ">
                <label><strong>Localização:</strong> {{itemData.location}}</label>
            </div>
            <div class="po-col po-sm-12 ">
                <label><strong>Tipo de Saldo:</strong> {{itemData.balanceType}}</label>
            </div>
            <div class="po-col po-sm-12 " *ngIf="itemData.orderRelation">
                <label><strong>Relacionamento com Pedido:</strong> {{itemData.orderRelation}}</label>
            </div>
            <div class="po-col po-sm-12 " *ngIf="itemData.transactionRelation">
                <label><strong>Relacionamento com Transação:</strong> {{itemData.transactionRelation}}</label>
            </div>
        </div>
    </po-widget>
</po-page-default>
<app-toaster></app-toaster>